import axios from 'axios';
import { DHLError, axiosRequest, handleHttpResponse } from '@general/js/utils';
import { Services } from '@/services/Services';
import MyDocumentsAbstractServices from './MyDocumentsAbstractServices';

export default class MyDocumentsServices extends MyDocumentsAbstractServices {
  /**
   * Returns reference data / content for My Documents
   *
   * @returns {object} - Reference data object
   */
  static async getReferenceData() {
    try {
      const response = await axios.get(Services.MY_COVER.MY_DOCUMENTS.GET_REFERENCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getReferenceData() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Returns document summary for all members in the policy from OCE
   *
   * @param {string} memberNumber - Member number (policy number) of the policy
   * @returns {object}
   */
  static async getDocumentSummary(memberNumber) {
    try {
      const response = await axiosRequest().get(Services.MY_COVER.MY_DOCUMENTS.GET_DOCUMENT_SUMMARY(memberNumber));

      if (handleHttpResponse(response) && response?.data?.documents) {
        return response.data.documents;
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getDocumentSummary() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Returns the the selected file from the document summary table
   *
   * @param {string} memberNumber - Member number (policy number) of the policy
   * @param {string} accessingPersonCode - Person code of who's tax statement document is being accessed
   * @param {string} documentId - Document Id of the document to be fetched
   * @returns {object}
   */
  static async getDocumentFile(memberNumber, accessingPersonCode, documentId) {
    try {
      const response = await axiosRequest().get(Services.MY_COVER.MY_DOCUMENTS.GET_DOCUMENT(memberNumber, accessingPersonCode, documentId));

      if (handleHttpResponse(response) && response?.data?.file?.data) {
        return response.data.file.data;
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getDocumentFile() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
